export const LOCAL_STORAGE_KEY = 'costsAndFeesOptions';
export const EXPIRATION_TIME_DAYS = 90;
